import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3efdcc72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }

import { useRouter } from 'vue-router'
import { ref, provide } from 'vue'
import { useI18n } from 'vue-i18n'

import IconButton from '@/popup/components/shared/IconButton.vue'
import AppIdenticon from '@/popup/components/shared/AppIdenticon/AppIdenticon.vue'
import { useAppStore } from '@/popup/store/AppStore'
import {
  assertAndShowSomethingWentWrongError,
  useNotifications,
} from '@/popup/compositions/useNotifications'
import { DBNotifications } from '@/shared/apis/bgnotifications'
import { ToastType } from '@/shared/models/AppNotification'
import { saveLastState } from '@/popup/storage/Database'
import getUniqueId from '@/shared/getUniqueId'
import { ProfileDTO } from '@/business-logic/wallet'
import { InternalMethods } from '@/shared/apis/messages'
import { useGlobals } from '@/popup/compositions/useGlobals'

export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreFrame',
  setup(__props) {

const { t } = useI18n({ useScope: 'global' })

const { sendMessage } = useGlobals()
const router = useRouter()
const appStore = useAppStore()
const notifications = useNotifications()

const profiles = ref<ProfileDTO[]>()
provide('profiles', profiles)

const backupPassword = ref('')
const report = ref<string>()

const onRestoreCancel = async () => {
  saveLastState({ path: '/' })
  await (appStore.selectedProfile ? router.back() : router.push('/'))
}

const onReportChecked = async (
  profilesValue: ProfileDTO[],
  backupPasswordValue: string,
  reportValue: string
) => {
  profiles.value = profilesValue
  backupPassword.value = backupPasswordValue
  report.value = reportValue

  assertAndShowSomethingWentWrongError(
    profilesValue.length > 0,
    'Expected profilesValue to have at least one profile in RestoreFrame:onReportChecked()'
  )

  if (profilesValue.length === 1) {
    router.push({ name: 'confirm-single' })
    return
  }

  router.push({ name: 'confirm-multiple' })
}

const onRestoreConfirm = async () => {
  assertAndShowSomethingWentWrongError(
    report.value,
    'Expected report to be defined in RestoreFrame:onRestoreConfirm()'
  )
  await sendMessage({
    method: InternalMethods.RESTORE_PROFILES,
    payload: {
      report: report.value,
      backupPassword: backupPassword.value,
    },
  })

  const lengthOfProfiles = profiles.value?.length ?? 0
  const message = t('restore_wizard.number_of_restored_profiles', {
    profilesAdded: `${
      lengthOfProfiles === 1
        ? '1 Profile'
        : `${lengthOfProfiles} of ${lengthOfProfiles} Profiles`
    }`,
  })
  notifications.updateToast({
    id: getUniqueId(),
    method: DBNotifications.NOTIFICATION,
    profileAddress: '',
    message,
    type: ToastType.SUCCESS,
    system: true,
    isPersistent: false,
  })

  await router.push('/')
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppIdenticon),
    _createVNode(IconButton, {
      onOnClick: onRestoreCancel,
      class: "mt-5"
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view, {
        onOnReportChecked: onReportChecked,
        onOnRestoreCancel: onRestoreCancel,
        onOnRestoreConfirm: onRestoreConfirm
      })
    ])
  ]))
}
}

})